(function() {
    'use strict';
 

a3_pilot_reports.factory('SyncLogFactory',SyncLogFactory);

/* @ngInject */ 
function SyncLogFactory($log,GenericService){
								
	// Define the constructor function.
	function SyncLog() {
		this.userAimsId = null;
		this.date = null;
		this.version = null;
		this.lastShow = null;
        this.isUpdated = false;
		this.lastScheduleDate = null;
		this.forceSync = false;
		//checks if sync log displayed in the last X minutes, to avoid constantly
		//showing the sync dialog
		this.canShowSync = canShowSync;
	}
		
		var objType = 'syncLog';
		var objCallback = SyncLog; 
																						
		var service = {
				getSyncLog : getSyncLog,
				setSyncLog : setSyncLog,
				updateSyncVersion : updateSyncVersion,
				setLastShow : setLastShow,
				clearSyncLog : clearSyncLog,
                getLastScheduleDate : getLastScheduleDate,
				setLastScheduleDate : setLastScheduleDate,
				forceSync : forceSync
		}
		
		function canShowSync(){
				var can = false;
				if (this.lastShow == null)
						can = true;
				else if ((new Date()).add(-10).minutes().toUTC().isAfter(new Date(this.lastShow).toUTC())) {
						can = true;
				}
				return can;
		}

	function getSyncLog(){
        return GenericService.getOne(objType,objCallback);
	}

	function setSyncLog(userAimsId,version,lastScheduleDate){
				var newLog = new SyncLog();
				newLog.userAimsId = userAimsId;
				newLog.date = new Date();
				newLog.version = version;
				newLog.lastShow = new Date();
				newLog.isUpdated = false;
				newLog.forceSync = false;
                newLog.lastScheduleDate = new Date(lastScheduleDate).getTime();
				GenericService.saveOne(newLog,objType,objCallback);
	}
		
		function updateSyncVersion(version){

				var syncLog = getSyncLog();
				
				syncLog.version=version;
				syncLog.isUpdated=true;

				GenericService.saveOne(syncLog,objType,objCallback);
		}
    
        function getLastScheduleDate() {
            var syncLog = getSyncLog();
            if (syncLog == null){
                return null;
            }else{   
			 return syncLog.lastScheduleDate;
            }
		}

		function setLastScheduleDate(date) {
            var log = getSyncLog();
			if (log == null) log = new SyncLog();
			log.lastScheduleDate = date;

			GenericService.saveOne(log,objType,objCallback);
		}

	
	function setLastShow(){
		var log = getSyncLog();
		if (log == null) log = new SyncLog();
		log.lastShow = new Date();
		
        GenericService.saveOne(log,objType,objCallback);
	}
	
	function clearSyncLog(){
		GenericService.removeAll(objType,objCallback);
	}
	
	/**
	 * Forces Sync Modal to appear
	 * @memberof SyncLogFactory
	 */
	function forceSync(){
		var syncLog = getSyncLog();
		if (syncLog == null) syncLog = new SyncLog();
		syncLog.forceSync = true;
		GenericService.saveOne(syncLog,objType,objCallback);
	}


	// Return constructor - this is what defines the actual
	// injectable in the DI framework.
	return service;
};

 })();   